import { Avatar, Grid } from "@mui/material";
import { AppImages } from "app/appImages";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { PublicationType } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { RootPaths } from "routes/RootRouter";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

export const AuthorDialog = () => {
    const { pub, otherInfo } = useCardContext();
    const { t } = useTranslation("knowledge");

    const actionName = pub.isDraft
        ? t("Feed.Card.Common.SaveDraftOnText")
        : pub.contentModifiedDate?.getTime() != pub.createdOn.getTime() && pub.supervisor == null
            ? t("Feed.Card.Common.ModifiedOnText")
            : pub.contentModifiedDate?.getTime() != pub.createdOn.getTime() && pub.supervisor != null
                ? t("Feed.Card.Common.EditedOnText")
                : pub.publicationType == PublicationType.Question
                    ? t("Feed.Card.Common.AskedOnText")
                    : pub.publicationType == PublicationType.Answer
                        ? t("Feed.Card.Common.AnsweredhOnText")
                        : t("Feed.Card.Common.PublishOnText");

    const actionDate = pub.isDraft
        ? pub.createdOn
        : pub.contentModifiedDate != pub.createdOn
            ? pub.contentModifiedDate
            : pub.createdOn;

    const avatarImg = pub.institutional != null
        ? pub.institutional.thumbnailUrl ?? AppImages.KnowledgeInstitutionalThumbnail
        : pub.author.thumbnailUrl;

    const authorName = pub.institutional != null
        ? pub.institutional.name
        : pub.isAnonymous
            ? t("Feed.Card.Common.AnonymousAuthorName")
            : pub.author.name;

    const RenderAuthorName = (
        <MprcFeedTypography variant="authorPrimary" component="div" noWrap>
            <span title={authorName}>{authorName}</span>
            {
                pub.supervisor != null &&
                <span> ({t("Feed.Card.Common.EditedBySupervisorText")})</span>
            }
        </MprcFeedTypography>
    );

    return (
        <Grid container justifyContent="center" alignItems="center" spacing={1} width="100%">
            {!pub.isAnonymous &&
                <Grid>
                    <Avatar src={avatarImg} title={authorName} />
                </Grid>
            }
            <Grid size="grow" overflow="hidden">
                {(pub.institutional != null || otherInfo.enableAuthorLink === false || pub.isAnonymous)
                    ? RenderAuthorName
                    : (
                        <Link
                            onClick={otherInfo?.onBeforeLinkClick == undefined ? undefined : otherInfo.onBeforeLinkClick()}
                            to={RootPaths.BuildUserProfile(pub.author.userId)}
                        >
                            {RenderAuthorName}
                        </Link>
                    )
                }

                <MprcFeedTypography variant="authorSecondary" component="div" noWrap>
                    <span>{actionName} {Formaters.relativeTime(actionDate)}</span>
                    {
                        !pub.isDraft && pub.channel?.name &&
                        <>
                            <span>&nbsp;{t("shared:Literal.At")}&nbsp;</span>
                            {
                                otherInfo?.enableChannelLink === true
                                    ? (
                                        <Link
                                            onClick={otherInfo?.onBeforeLinkClick == undefined ? undefined : otherInfo.onBeforeLinkClick()}
                                            to={KnowledgePaths.FeedChannel(pub.channel.id)}
                                        >
                                            <b>{pub.channel.name}</b>
                                        </Link>
                                    )
                                    : <b>{pub.channel.name}</b>
                            }
                        </>
                    }
                </MprcFeedTypography>
            </Grid>
        </Grid>
    );
};
